import { render, staticRenderFns } from "./InstitutionSettingsWorkdays.vue?vue&type=template&id=415302ca"
import script from "./InstitutionSettingsWorkdays.vue?vue&type=script&lang=js"
export * from "./InstitutionSettingsWorkdays.vue?vue&type=script&lang=js"
import style0 from "./InstitutionSettingsWorkdays.vue?vue&type=style&index=0&id=415302ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports